<template>
  <div class="form-container">
    <div class="form-card">
      <!-- 返回按钮 -->
      <div class="back-btn" @click="handleBack">
        <i class="el-icon-back back-icon"></i>
      </div>

      <!-- 标题 -->
      <h2 class="form-title">会员注册</h2>
      <p class="form-subtitle">请完整填写信息完成注册</p>

      <!-- 核心表单 -->
      <el-form
          ref="formRef"
          :model="formData"
          :rules="formRules"
          label-width="100%"
          label-position="top"
          class="main-form"
      >
        <!-- 1. 用户姓名 -->
        <el-form-item label="姓名" prop="userName">
          <el-input
              v-model="formData.userName"
              placeholder="请输入姓名"
              prefix-icon="el-icon-user"
              class="form-input"
          ></el-input>
        </el-form-item>

        <!-- 2. 手机号 -->
        <el-form-item label="手机号" prop="phoneNumber">
          <el-input
              v-model="formData.phoneNumber"
              placeholder="请输入11位手机号"
              prefix-icon="el-icon-phone"
              maxlength="11"
              class="form-input"
          ></el-input>
        </el-form-item>

        <!-- 3. 密码 -->
        <el-form-item label="密码" prop="password">
          <el-input
              v-model="formData.password"
              placeholder="请输入6-16位密码"
              prefix-icon="el-icon-lock"
              show-password
              class="form-input"
          ></el-input>
        </el-form-item>

        <!-- 4. 确认密码 -->
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
              v-model="formData.confirmPassword"
              placeholder="请再次输入密码"
              prefix-icon="el-icon-lock"
              show-password
              class="form-input"
          ></el-input>
        </el-form-item>

        <!-- 5. 身份证号（非必填） -->
        <el-form-item label="身份证号" prop="identityCard">
          <el-input
              v-model="formData.identityCard"
              placeholder="请输入身份证号（选填）"
              prefix-icon="el-icon-user-solid"
              maxlength="18"
              class="form-input"
          ></el-input>
        </el-form-item>

        <!-- 单个地址文本框 -->
        <el-form-item label="联系地址" prop="address">
          <el-input
              v-model="formData.address"
              placeholder="请输入联系地址"
              prefix-icon="el-icon-location"
              class="form-input"
          ></el-input>
        </el-form-item>

        <!-- 动态球杆信息分组 -->
        <div class="cue-group-container">
          <h3 class="cue-group-title">球杆信息</h3>
          <!-- 循环渲染球杆信息分组 -->
          <div
              v-for="(group, index) in formData.cueGroups"
              :key="`cue-group-${index}`"
              class="cue-group-item"
          >
            <div class="group-header">
              <span class="group-label">球杆{{ index + 1 }}</span>
              <!-- 仅当分组数量大于1时显示删除按钮 -->
              <div class="group-actions">
                <el-button
                    v-if="formData.cueGroups.length > 1"
                    type="text"
                    icon="el-icon-delete"
                    class="delete-group-btn"
                    @click="handleDeleteGroup(index)"
                >
                  删除
                </el-button>
              </div>
            </div>

            <el-form-item
                :prop="`cueGroups[${index}].number`"
                :rules="cueGroupRules.number"
                label="球杆编号"
                :error="getCueNumberError(index)"
            >
              <el-input
                  v-model="group.number"
                  placeholder="请输入球杆编号"
                  prefix-icon="el-icon-s-tools"
                  class="form-input"
                  @blur="validateCueNumberUnique(index)"
              ></el-input>
            </el-form-item>

            <!-- 球杆品牌 -->
            <el-form-item
                :prop="`cueGroups[${index}].brand`"
                :rules="cueGroupRules.brand"
                label="球杆品牌"
            >
              <el-input
                  type="text"
                  v-model="group.brand"
                  placeholder="请选择球杆品牌"
                  @keydown.prevent
                  @click.native="openSelectDialog(index)"
                  readonly
                  class="form-input"
                  prefix-icon="el-icon-s-goods"
              ></el-input>
            </el-form-item>

            <!-- 球杆型号 -->
            <el-form-item
                :prop="`cueGroups[${index}].model`"
                :rules="cueGroupRules.model"
                label="球杆型号"
            >
              <el-input
                  v-model="group.model"
                  placeholder="请输入球杆型号"
                  @keydown.prevent
                  @click.native="openModelSelectDialog(index)"
                  readonly
                  prefix-icon="el-icon-s-order"
                  class="form-input"
              ></el-input>
            </el-form-item>

            <!-- 购买渠道 -->
            <el-form-item
                :prop="`cueGroups[${index}].channel`"
                :rules="cueGroupRules.channel"
                label="购买渠道"
            >
              <el-input
                  v-model="group.channel"
                  placeholder="请输入购买渠道"
                  prefix-icon="el-icon-s-shop"
                  class="form-input"
              ></el-input>
            </el-form-item>

            <!-- 购买价格 -->
            <el-form-item
                :prop="`cueGroups[${index}].price`"
                :rules="cueGroupRules.price"
                label="购买价格（元）"
            >
              <el-input
                  v-model="group.price"
                  placeholder="请输入购买价格"
                  prefix-icon="el-icon-money"
                  type="number"
                  class="form-input"
              ></el-input>
            </el-form-item>

            <!-- 购买时间 -->
            <el-form-item
                :prop="`cueGroups[${index}].startTime`"
                :rules="cueGroupRules.startTime"
                label="购买时间"
            >
              <el-input
                  type="text"
                  v-model="group.startTime"
                  placeholder="点击选择购买日期"
                  @keydown.prevent
                  @click.native="openDateDrawer(index)"
                  readonly
                  class="form-input"
                  prefix-icon="el-icon-s-goods"
              ></el-input>
            </el-form-item>

            <!-- 购买凭证（图片上传） -->
            <el-form-item
                :prop="`cueGroups[${index}].proof`"
                :rules="cueGroupRules.proof"
                label="购买凭证"
            >
              <!-- 提示语 -->
              <div class="voucher-tip">单张≤5MB，最多上传3张</div>
              <div class="upload-wrap">
                <el-upload
                    class="avatar-uploader"
                    action="#"
                    accept="image/jpeg,image/png"
                    :on-change="(file, fileList) => handleFileChange(file, fileList, index)"
                    :file-list="group.fileList"
                    list-type="picture-card"
                    :on-preview="(file) => handlePreview(file, index)"
                    :on-remove="(file) => handleFileRemove(file, index)"
                    :limit="3"
                    :on-exceed="handleExceed"
                    :auto-upload="false"
                    multiple
                >
                  <i class="el-icon-plus upload-icon"></i>
                </el-upload>
              </div>
            </el-form-item>
          </div>

          <!-- 新增分组按钮 -->
          <el-button
              type="dashed"
              icon="el-icon-plus"
              class="add-group-btn"
              @click="handleAddGroup"
          >
            新增球杆信息
          </el-button>
        </div>

        <!-- 提交按钮组 -->
        <el-form-item class="submit-btn-group">
          <el-button
              type="primary"
              size="large"
              :loading="isLoading"
              @click="handleSubmit"
              class="submit-btn"
          >
            提交注册
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 图片预览弹窗 -->
    <el-dialog :visible.sync="dialogVisible" title="图片预览" width="90%" append-to-body>
      <img
          v-if="dialogImageUrl"
          :src="dialogImageUrl"
          alt="预览图"
          style="width: 100%; max-height: 80vh; object-fit: contain;"
          @error="handleImageError"
      />
    </el-dialog>

    <!-- 调用弹框组件 -->
    <MessageDialog
        v-if="showDialog"
        :title="dialogTitle"
        :content="messageContent"
        confirmText="我知道了"
        :jump-to="jumpTo"
        @confirm="showDialog = false"
        :close-on-mask="true"
    />

    <!-- 引入自定义select组件 -->
    <SelectDialog
        :visible="selectDialogVisible"
        :options="selectOptions"
        :active-value="currentFormIndex !== -1 ? formData.cueGroups[currentFormIndex].brand : ''"
        @select="handleSelect"
        @close="selectDialogVisible = false"
    />

    <!--  型号select组件  -->
    <SelectDialog
        :visible="selectModelDialogVisible"
        :options="selectOptions"
        :active-value="currentFormIndex !== -1 ? formData.cueGroups[currentFormIndex].model : ''"
        @select="handleSelectModel"
        @close="selectModelDialogVisible = false"
    />

    <!-- 引入自定义日期抽屉组件 -->
    <DatePickerDrawer
        :visible="dateDrawerVisible"
        :init-date="currentDateRowIndex !== -1 ? formData.cueGroups[currentDateRowIndex].startTime : ''"
        @confirm="handleDateConfirm"
        @close="dateDrawerVisible = false"
    />
  </div>
</template>

<script>
import { Message } from 'element-ui'
import MessageDialog from "@/views/business/utils/messageDialog.vue";
import {brandDropDown, memberRegister} from "@/api/sales";
import DatePickerDrawer from "@/views/business/utils/datePickerDrawer.vue";
import SelectDialog from "@/views/business/utils/selectDialog.vue";

export default {
  name: 'CompleteRegisterForm',
  components: {SelectDialog, DatePickerDrawer, MessageDialog },
  data() {
    // 用户名校验：仅中文/字母，2-10位
    const validateUsername = (rule, value, callback) => {
      if (!value) return callback(new Error('请输入用户姓名'))
      const nameReg = /^[\u4e00-\u9fa5a-zA-Z]{2,10}$/
      if (!nameReg.test(value)) {
        callback(new Error('姓名仅支持中文/字母，长度2-10位'))
      } else {
        callback()
      }
    }

    // 手机号校验
    const validatePhone = (rule, value, callback) => {
      if (!value) return callback(new Error('请输入手机号'))
      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(value)) {
        callback(new Error('请输入有效的11位手机号'))
      } else {
        callback()
      }
    }

    // 密码校验
    const validatePassword = (rule, value, callback) => {
      if (!value) return callback(new Error('请输入密码'))
      if (value.length < 6 || value.length > 16) {
        callback(new Error('密码长度需在6-16位之间'))
      } else {
        // 密码输入后，触发确认密码校验
        this.$refs.formRef?.validateField('confirmPassword')
        callback()
      }
    }

    // 确认密码校验
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) return callback(new Error('请确认密码'))
      if (value !== this.formData.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }

    // 身份证号校验（可选）
    const validateIdCard = (rule, value, callback) => {
      if (!value) return callback() // 非必填，为空直接通过
      const idCardReg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (!idCardReg.test(value)) {
        callback(new Error('请输入有效的18位身份证号'))
      } else {
        callback()
      }
    }

    // 单个地址校验
    const validateAddress = (rule, value, callback) => {
      if (!value) return callback(new Error('请输入联系地址'))
      if (value.length < 5 || value.length > 200) {
        callback(new Error('联系地址长度需在5-200位之间'))
      } else {
        callback()
      }
    }

    // 球杆品牌校验（必填）
    const validateBrand = (rule, value, callback) => {
      if (!value) return callback(new Error('请选择球杆品牌'))
      callback()
    }

    // 球杆型号校验（必填，1-30位字符）
    const validateModel = (rule, value, callback) => {
      if (!value) return callback(new Error('请选择球杆型号'))
      callback()
    }

    // 球杆编号校验
    const validateCueCode = (rule, value, callback) => {
      if (!value) return callback(new Error('请输入球杆编号'))
      callback()
    }

    // 购买渠道校验
    const validateBuyChannel = (rule, value, callback) => {
      if (!value) return callback(new Error('请输入购买渠道'))
      callback()
    }

    // 购买价格校验
    const validateBuyPrice = (rule, value, callback) => {
      if (!value) return callback(new Error('请输入购买价格'))
      if (Number(value) <= 0) {
        callback(new Error('购买价格需大于0'))
      } else {
        callback()
      }
    }

    // 购买时间校验（必填）
    const validateBuyTime = (rule, value, callback) => {
      if (!value) return callback(new Error('请选择购买时间'))
      callback()
    }

    // 购买凭证校验
    const validateBuyVoucher = (rule, value, callback) => {
      // 从对应分组中获取fileList
      const groupIndex = rule.field.match(/cueGroups\[(\d+)\]/)[1]
      const fileList = this.formData.cueGroups[groupIndex].fileList
      if (fileList.length === 0) {
        callback(new Error('请上传购买凭证图片'))
      } else {
        callback()
      }
    }

    return {
      // 表单数据
      formData: this.loadSavedData() || {
        userName: '',         // 用户姓名
        phoneNumber: '',      // 手机号
        password: '',         // 密码
        confirmPassword: '',  // 确认密码
        identityCard: '',     // 身份证号（非必填）
        address: '',          // 联系地址
        // 球杆信息分组
        cueGroups: [{
          number: '',         // 球杆编号
          brandCode: '',
          brand: '',          // 球杆品牌（下拉选择值）
          modelCode: '',          // 球杆型号
          model: '',          // 球杆型号
          channel: '',        // 购买渠道
          price: '',          // 购买价格
          startTime: '',      // 购买时间（格式：yyyy-MM-dd）
          proof: [],          // 购买凭证文件ID（数组）
          fileList: []        // 上传文件列表（每个分组独立）
        }]
      },
      // 表单校验规则
      formRules: {
        userName: [{ required: true, validator: validateUsername, trigger: 'blur' }],
        phoneNumber: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        password: [{ required: true, validator: validatePassword, trigger: 'blur' }],
        confirmPassword: [{ required: true, validator: validateConfirmPassword, trigger: 'blur' }],
        identityCard: [{ validator: validateIdCard, trigger: 'blur' }],
        address: [{ required: true, validator: validateAddress, trigger: 'blur' }]
      },
      // 球杆分组校验规则
      cueGroupRules: {
        number: [{ required: true, validator: validateCueCode, trigger: 'blur' }],
        brand: [{ required: true, validator: validateBrand, trigger: 'change' }],
        model: [{ required: true, validator: validateModel, trigger: 'blur' }],
        channel: [{ required: true, validator: validateBuyChannel, trigger: 'blur' }],
        price: [{ required: true, validator: validateBuyPrice, trigger: 'blur' }],
        startTime: [{ required: true, validator: validateBuyTime, trigger: 'change' }],
        proof: [{ required: true, validator: validateBuyVoucher, trigger: 'change' }]
      },
      selectOptions: [
        // { label: '美洲豹', value: '美洲豹' },
        // { label: '环球', value: '环球' },
        // { label: '毒药', value: '毒药' },
        // { label: '鬼斧', value: '鬼斧' }
      ],
      selectBrandDrop:[],
      // 加载状态
      isLoading: false,
      // 球杆编号重复错误信息
      cueNumberErrors: {},
      // 提示弹框组件
      showDialog: false,
      dialogTitle: '提示',
      messageContent: '',
      jumpTo: '',
      dialogVisible: false,
      dialogImageUrl: '',
      // 防抖验证
      validateFileDebounce: null,

      //select弹框组件
      selectDialogVisible: false,
      selectModelDialogVisible: false,
      currentFormIndex: -1, // 新增：记录当前点击的表单行索引

      // 日期抽屉相关
      dateDrawerVisible: false, // 日期抽屉显示状态
      currentDateRowIndex: -1,  // 当前点击的表单行索引
    }
  },
  watch: {
    // 监听表单数据变化，实现自动保存
    formData: {
      handler() {
        this.saveFormData()
      },
      deep: true,
      immediate: false
    }
  },
  mounted() {
    // 初始化防抖函数
    this.validateFileDebounce = this.debounce(this.validateFileList, 300)

    // 适配键盘弹出时的容器高度
    window.addEventListener('resize', this.adjustContainerHeight)
    // 初始化容器高度
    this.adjustContainerHeight()

    this.selectBrandDropDown();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.adjustContainerHeight)
  },
  methods: {
    async selectBrandDropDown(){
      try {
        const response = await brandDropDown();
        if(response.code===200){
          this.selectBrandDrop = response.data;
        }
      } catch (error) {
        console.error("获取产品失败:", error);
      }
    },
    // 打开日期抽屉
    openDateDrawer(index) {
      this.currentDateRowIndex = index; // 记录当前行索引
      this.dateDrawerVisible = true;    // 显示抽屉
    },

    // 确认选择日期（绑定到对应行）
    handleDateConfirm(formattedDate) {
      if (this.currentDateRowIndex !== -1) {
        // 赋值到对应行的购买时间
        this.formData.cueGroups[this.currentDateRowIndex].startTime = formattedDate;
      }
      this.dateDrawerVisible = false; // 关闭抽屉
    },

    openSelectDialog(index){
      this.currentFormIndex = index; // 记录当前行
      this.selectDialogVisible = true; // 打开弹框

      this.selectOptions = this.selectBrandDrop.map(item=>({
        label: item.value,
        value: item.label
      }));
    },
    //打开型号弹框
    openModelSelectDialog(index){

      if(!this.formData.cueGroups[index].brandCode){
        //提示信息提示弹框组件是否显示
        this.showDialog = true;
        //显示取消按钮
        this.showCancel = false;
        //确认按钮文案
        this.confirmText = "我知道了";
        //提示信息内容
        this.messageContent = "请先选择球杆品牌！";
        return;
      }

      this.currentFormIndex = index; // 记录当前行
      this.selectModelDialogVisible = true; // 打开弹框

      this.selectOptions = this.selectBrandDrop
              .find(parent => parent.label === this.formData.cueGroups[index].brandCode)
              ?.children // 安全地获取其 children 数组
              .map(child => ({ label: child.value, value: child.label })) // 对 children 数组进行 map 转换
          ?? []; // 如果前面任何一步失败(结果为null或undefined)，则返回一个空数组
    },

    handleSelect(item) {
      if (this.currentFormIndex !== -1) {
        // this.formData.cueGroups[this.currentFormIndex].brand = item.value; // 赋值到对应行
        this.formData.cueGroups[this.currentFormIndex].brand = item.label; // 赋值到对应行
        this.formData.cueGroups[this.currentFormIndex].brandCode = item.value; // 赋值到对应行
      }
      this.selectDialogVisible = false; // 关闭弹框
    },
    handleSelectModel(item){
      if (this.currentFormIndex !== -1) {
        this.formData.cueGroups[this.currentFormIndex].model = item.label; // 赋值到对应行
        this.formData.cueGroups[this.currentFormIndex].modelCode = item.value; // 赋值到对应行
      }
      this.selectModelDialogVisible = false; // 关闭弹框
    },

    // 防抖函数
    debounce(func, wait) {
      let timeout
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout)
          func(...args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
      }
    },

    // 加载本地保存的表单数据
    loadSavedData() {
      try {
        const saved = localStorage.getItem('registerFormData')
        if (saved) {
          const data = JSON.parse(saved)
          // 恢复fileList为空数组，因为File对象无法序列化
          if (data.cueGroups) {
            data.cueGroups.forEach(group => {
              group.fileList = []
              group.proof = []
            })
          }
          return data
        }
      } catch (e) {
        console.error('加载本地数据失败:', e)
      }
      return null
    },

    // 保存表单数据到本地
    saveFormData() {
      try {
        // 不保存文件数据，只保存文本数据
        const dataToSave = {
          ...this.formData,
          cueGroups: this.formData.cueGroups.map(group => ({
            ...group,
            fileList: [], // 清除文件数据
            proof: []     // 清除凭证数据
          }))
        }
        localStorage.setItem('registerFormData', JSON.stringify(dataToSave))
      } catch (e) {
        console.error('保存数据失败:', e)
      }
    },

    // 适配容器高度
    adjustContainerHeight() {
      const container = document.querySelector('.form-container')
      if (container && window.innerWidth <= 768) {
        container.style.minHeight = `${window.innerHeight}px`
      }
    },

    // 返回上一页
    handleBack() {
      this.$router.replace('/sales_login')
    },

    // 新增球杆信息分组
    handleAddGroup() {
      if (this.formData.cueGroups.length >= 5) {
        this.showDialog = true
        this.dialogTitle = '提示'
        this.messageContent = '最多只能添加5个球杆信息'
        return
      }

      this.formData.cueGroups.push({
        number: '',         // 球杆编号
        brand: '',          // 球杆品牌（下拉选择值）
        model: '',          // 球杆型号
        brandCode: '',          // 球杆品牌（下拉选择值）
        modelCode: '',          // 球杆型号
        channel: '',        // 购买渠道
        price: '',          // 购买价格
        startTime: '',      // 购买时间
        proof: [],          // 购买凭证文件ID（数组）
        fileList: []        // 上传文件列表
      })
    },

    // 删除球杆信息分组
    handleDeleteGroup(index) {
      this.$confirm(`确定要删除球杆${index + 1}的信息吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.formData.cueGroups.splice(index, 1)
        // 删除后重新校验表单
        this.$refs.formRef?.validate()
        // 清除该分组的编号错误
        this.$delete(this.cueNumberErrors, index)
        Message.success('删除成功')
      }).catch(() => {})
    },

    // 验证球杆编号唯一性
    validateCueNumberUnique(index) {
      const currentNumber = this.formData.cueGroups[index].number
      if (!currentNumber) return

      const numbers = this.formData.cueGroups.map(g => g.number)
      const duplicateIndex = numbers.findIndex((num, i) =>
          i !== index && num === currentNumber
      )

      if (duplicateIndex !== -1) {
        this.$set(this.cueNumberErrors, index, `球杆编号"${currentNumber}"与球杆${duplicateIndex + 1}重复`)
      } else {
        this.$delete(this.cueNumberErrors, index)
      }
    },

    // 获取球杆编号错误信息
    getCueNumberError(index) {
      return this.cueNumberErrors[index] || ''
    },


    // 图片上传处理
    handleFileChange(file, fileList, index) {
      // 1. 仅处理「文件添加」的场景（status=ready）
      if (file.status !== 'ready') {
        return
      }

      const rawFile = file.raw
      // 2. 校验文件类型（仅jpg/png）
      const isJpgPng = rawFile.type === 'image/jpeg' || rawFile.type === 'image/png'
      if (!isJpgPng) {
        this.showDialog = true
        this.dialogTitle = '错误提示'
        this.messageContent = '只能上传jpg/png格式的图片！'
        // 移除错误文件
        this.formData.cueGroups[index].fileList = fileList.filter(item => item.uid !== file.uid)
        return
      }

      // 3. 校验文件大小（≤5MB）
      const isLt5M = rawFile.size / 1024 / 1024 <= 5
      if (!isLt5M) {
        this.showDialog = true
        this.dialogTitle = '错误提示'
        this.messageContent = '图片大小不能超过5MB！'
        // 移除错误文件
        this.formData.cueGroups[index].fileList = fileList.filter(item => item.uid !== file.uid)
        return
      }


      // 4. 生成预览URL并更新fileList
      const reader = new FileReader()
      reader.readAsDataURL(rawFile)
      reader.onload = (e) => {
        this.formData.cueGroups[index].fileList = fileList.map(item => {
          if (item.uid === file.uid) {
            return {
              ...item,
              url: e.target.result, // 预览URL
              raw: rawFile          // 保存原生File对象（提交时用）
            }
          }
          return item
        })
        // 重新校验凭证字段
        this.$refs.formRef?.validateField(`cueGroups[${index}].proof`)
      }
    },

    // 防抖验证文件列表
    validateFileList(index) {
      this.$refs.formRef?.validateField(`cueGroups[${index}].proof`)
    },

    // 图片预览
    handlePreview(file) {
      if (file.url) {
        this.dialogImageUrl = file.url
      } else if (file.raw) {
        // 重新生成预览URL
        const reader = new FileReader()
        reader.readAsDataURL(file.raw)
        reader.onload = (e) => {
          this.dialogImageUrl = e.target.result
        }
      } else {
        this.dialogImageUrl = ""
        this.showDialog = true
        this.dialogTitle = '错误提示'
        this.messageContent = "该图片无预览地址！"
      }
      this.dialogVisible = true
    },

    // 超出数量提示
    handleExceed() {
      this.showDialog = true
      this.dialogTitle = '提示'
      this.messageContent = '最多只能上传3张图片！'
    },

    // 预览错误处理
    handleImageError() {
      this.dialogImageUrl = ""
      this.showDialog = true
      this.dialogTitle = '错误提示'
      this.messageContent = "图片预览失败，请重新上传！"
    },

    // 删除上传文件（关联对应分组）
    handleFileRemove(file, index) {
      // 清空对应分组的文件ID
      this.formData.cueGroups[index].proof = []
      // 重新校验该分组的凭证字段
      this.$refs.formRef?.validateField(`cueGroups[${index}].proof`)
    },

    // 提交表单
    async handleSubmit() {
      try {
        // 1. 表单校验
        await this.$refs.formRef.validate()
      } catch (err) {
        Message.warning('请检查表单填写是否完整！')
        return
      }

      // 2. 验证球杆编号唯一性
      const numbers = this.formData.cueGroups.map(g => g.number)
      const duplicateNumbers = numbers.filter((num, index) =>
          num && numbers.indexOf(num) !== index
      )

      if (duplicateNumbers.length > 0) {
        this.showDialog = true
        this.dialogTitle = '提示'
        this.messageContent = '球杆编号不能重复，请修改后重试'
        return
      }

      // 3. 验证是否有未处理的编号错误
      if (Object.keys(this.cueNumberErrors).length > 0) {
        this.showDialog = true
        this.dialogTitle = '提示'
        this.messageContent = '请先解决球杆编号重复的问题'
        return
      }

      this.isLoading = true
      try {
        const formData = new FormData()

        // 4. 填充基础字段
        formData.append('userName', this.formData.userName)
        formData.append('phoneNumber', this.formData.phoneNumber)
        formData.append('password', this.formData.password)
        formData.append('identityCard', this.formData.identityCard || '')
        formData.append('address', this.formData.address)

        // 5. 填充球杆信息列表
        for (let i = 0; i < this.formData.cueGroups.length; i++) {
          const group = this.formData.cueGroups[i]
          const { fileList, ...pureGroup } = group

          // 价格转数字
          const price = Number(pureGroup.price) || 0

          // 按后端List接收格式填充
          formData.append(`productList[${i}].number`, pureGroup.number)
          formData.append(`productList[${i}].brand`, pureGroup.brand)
          formData.append(`productList[${i}].brandCode`, pureGroup.brandCode)
          formData.append(`productList[${i}].modelCode`, pureGroup.modelCode)
          formData.append(`productList[${i}].model`, pureGroup.model)
          formData.append(`productList[${i}].channel`, pureGroup.channel)
          formData.append(`productList[${i}].price`, price)
          formData.append(`productList[${i}].startTime`, pureGroup.startTime)

          // 6. 填充文件（安全格式）
          for (let j = 0; j < fileList.length; j++) {
            const file = fileList[j]
            if (file.raw) {
              // 使用压缩后的文件
              formData.append(pureGroup.number, file.raw)
            }
          }
        }

        // 7. 提交注册
        const res = await memberRegister(formData)
        if (res.code === 200) {
          this.showDialog = true
          this.dialogTitle = '提示'
          this.messageContent = res.returnMsg || (res.code === 200 ? '注册成功！' : '注册失败，请重试')
          // 注册成功跳转
            // 清除本地保存的数据
            localStorage.removeItem('registerFormData')
            this.jumpTo = '/sales_login'
        }else{
          this.showDialog = true
          this.dialogTitle = '提示'
          this.messageContent = res.returnMsg || '注册失败，请重试';
        }
      } catch (error) {
        this.showDialog = true
        this.dialogTitle = '错误提示'
        this.messageContent = error.message || '网络异常，请稍后再试'
        console.error('注册失败：', error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
// 基础样式（全设备通用）
body {
  touch-action: manipulation;
  user-select: none;
  margin: 0;
  padding: 0;
}

::v-deep .el-form {
  --el-form-border-color: transparent;
}

.form-container {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #409eff, #67c23a);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  // iOS Safari特殊处理
  @supports (-webkit-touch-callout: none) {
    min-height: -webkit-fill-available;
  }
}

.form-card {
  width: 100%;
  background: #fff;
  border-radius: 24px;
  padding: 40px 28px;
  box-sizing: border-box;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  position: relative;
  margin-top: 20px;
}

// 返回按钮（基础）
.back-btn {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #f5f7fa;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 2;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  &:active {
    background-color: #e8f4f8;
    transform: scale(0.95);
  }
}

.back-icon {
  font-size: 20px;
  color: #409eff;
}

// 标题样式（基础）
.form-title {
  font-size: 26px;
  color: #333;
  text-align: center;
  margin: 0 0 10px 0;
  font-weight: 700;
  padding-left: 10px;
}

.form-subtitle {
  font-size: 15px;
  color: #666;
  text-align: center;
  margin-bottom: 30px;
  padding-left: 10px;
}

// 球杆分组标题（基础）
.cue-group-title {
  font-size: 18px;
  color: #333;
  margin: 10px 0 15px 0;
  font-weight: 600;
}

// 球杆分组容器（基础）
.cue-group-container {
  width: 100%;
  margin-bottom: 10px;
}

// 单个分组样式（基础）
.cue-group-item {
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 15px;
  margin-bottom: 15px;
}

// 分组头部（编号+操作按钮）（基础）
.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.group-label {
  font-size: 16px;
  color: #409eff;
  font-weight: 500;
}

.group-actions {
  display: flex;
  gap: 10px;
}

.delete-group-btn {
  color: #f56c6c;
  font-size: 14px;
  padding: 0;
}

.reset-group-btn {
  color: #909399;
  font-size: 14px;
  padding: 0;
}

// 新增分组按钮（基础）
.add-group-btn {
  width: 100%;
  height: 48px;
  border-radius: 18px;
  font-size: 16px;
  color: #409eff;
  margin-bottom: 10px;
}

// 基础输入框/日期选择器样式统一（基础）
.form-input, ::v-deep .el-date-editor {
  width: 100%;
  font-size: 16px;
  border-radius: 18px;
  border: 1px solid #e5e5e5;
  margin-bottom: 4px;
  box-sizing: border-box;
}

// 普通输入框/选择器高度（基础）
.form-input:not(textarea), ::v-deep .el-date-editor {
  height: 48px;
  padding: 0 48px;
}

// 多行文本框（地址）样式（基础）
::v-deep .el-textarea__inner {
  border-radius: 18px;
  padding: 12px 16px;
  font-size: 16px;
  line-height: 1.4;
  border: 1px solid #e5e5e5;
}

// 前缀图标居中（适配所有输入类组件）（基础）
::v-deep .el-input__prefix,
::v-deep .el-date-editor .el-input__prefix {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 100%;
  transform: none;
}

::v-deep .el-input__prefix i,
::v-deep .el-date-editor .el-input__prefix i {
  font-size: 18px;
  color: #409eff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

// 输入框内容区（基础）
::v-deep .el-input__inner {
  height: 100%;
  line-height: 48px;
  font-size: 14px;
  border: none;
  padding: 0;
}

// 密码/确认密码显隐按钮放大（基础）
::v-deep .el-input__suffix {
  width: 40px;
  height: 40px;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

::v-deep .el-input__suffix i {
  font-size: 24px;
  color: #409eff;
  width: 100%;
  height: 100%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

// 表单标签样式（基础）
::v-deep .el-form-item__label {
  font-size: 16px;
  color: #555;
  margin-bottom: 10px;
  font-weight: 500;
  line-height: 1.2;
}

// 错误提示（基础）
::v-deep .el-form-item__error {
  font-size: 12px;
  padding-top: 2px;
  padding-left: 10px;
}

::v-deep .el-form-item {
  margin-bottom: 20px;
}

// 购买凭证提示语样式（基础）
.voucher-tip {
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
  line-height: 1.2;
}

// 上传组件样式（基础）
.upload-wrap {
  width: 100%;
}

.voucher-upload {
  border-radius: 12px;
  border: 1px dashed #e5e5e5;
  margin: 0 auto;
}

.upload-icon {
  font-size: 28px;
  color: #409eff;
  margin-bottom: 8px;
}

// 提交按钮组（基础）
.submit-btn-group {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  gap: 15px;
  padding: 0;
}

.submit-btn {
  width: 100%;
  min-width: 100px;
  max-width: 150px;
  height: 48px;
  font-size: 17px;
  border-radius: 10px;
  border: none;
  background: #409eff;
  color: #fff;

  &:hover {
    background: #3390ff;
  }

  &:disabled {
    background: #b3d8ff;
    color: #fff;
  }
}

// ========== 移动端适配（≤768px） ==========
@media screen and (max-width: 768px) {
  /* 整屏容器 */
  .form-container {
    padding: 20px;
    /* iOS Safari特殊处理 */
    @supports (-webkit-touch-callout: none) {
      min-height: -webkit-fill-available;
    }
  }

  /* 表单卡片 */
  .form-card {
    max-width: 400px;
    border-radius: 24px;
    padding: 40px 28px;
    margin-top: 20px;
  }

  /* 返回按钮 */
  .back-btn {
    top: 20px;
    left: 20px;
    width: 40px;
    height: 40px;
  }

  .back-icon {
    font-size: 20px;
  }

  /* 标题样式 */
  .form-title {
    font-size: 26px;
    margin-bottom: 10px;
  }

  .form-subtitle {
    font-size: 15px;
    margin-bottom: 30px;
  }

  /* 球杆分组标题 */
  .cue-group-title {
    font-size: 18px;
    margin: 10px 0 15px 0;
  }

  /* 单个分组样式 */
  .cue-group-item {
    border-radius: 12px;
    padding: 15px;
    margin-bottom: 15px;
  }

  /* 分组头部（编号+操作按钮） */
  .group-header {
    margin-bottom: 15px;
    padding-bottom: 10px;
  }

  .group-label {
    font-size: 16px;
  }

  .group-actions {
    gap: 10px;
  }

  .delete-group-btn {
    font-size: 14px;
  }

  /* 新增分组按钮 */
  .add-group-btn {
    width: 100%;
    height: 48px;
    border-radius: 18px;
    font-size: 16px;
    color: #409eff;
    margin-bottom: 10px;
  }

  /* 基础输入框/日期选择器样式统一 */
  .form-input {
    font-size: 16px;
    border-radius: 18px;
    margin-bottom: 4px;
  }

  /* 普通输入框/选择器高度 */
  .form-input:not(textarea){
    height: 48px;
    padding: 0 48px;
  }


  /* 前缀图标居中（适配所有输入类组件） */
  ::v-deep .el-input__prefix,
  ::v-deep .el-date-editor .el-input__prefix {
    width: 48px;
    height: 100%;
  }

  ::v-deep .el-input__prefix i,
  ::v-deep .el-date-editor .el-input__prefix i {
    font-size: 18px;
  }

  /* 输入框内容区 */
  ::v-deep .el-input__inner {
    height: 100%;
    line-height: 48px;
    font-size: 14px;
  }

  /* 密码/确认密码显隐按钮放大 */
  ::v-deep .el-input__suffix {
    width: 40px;
    height: 40px;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
  }

  ::v-deep .el-input__suffix i {
    font-size: 24px;
  }

  /* 表单标签样式 */
  ::v-deep .el-form-item__label {
    font-size: 16px;
    margin-bottom: 10px;
  }

  /* 错误提示 */
  ::v-deep .el-form-item__error {
    font-size: 12px;
    padding-top: 2px;
    padding-left: 10px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }

  /* 购买凭证提示语样式 */
  .voucher-tip {
    font-size: 12px;
    margin-bottom: 8px;
  }

  .voucher-upload {
    border-radius: 12px;
  }

  .upload-icon {
    font-size: 28px;
    margin-bottom: 8px;
  }

  /* 提交按钮组 */
  .submit-btn-group {
    margin-top: 40px;
    padding: 0;
  }

  .submit-btn {
    width: 100%;
    min-width: 100px;
    max-width: 150px;
    height: 48px;
    font-size: 17px;
    border-radius: 10px;
  }
}

// ========== 平板适配（769px - 1200px） ==========
@media screen and (min-width: 769px) and (max-width: 1200px) {
  .form-container {
    padding: 30px;
  }

  .form-card {
    max-width: 600px;
    padding: 50px 40px;
    margin-top: 30px;
  }

  // 返回按钮
  .back-btn {
    width: 44px;
    height: 44px;

    .back-icon {
      font-size: 22px;
    }
  }

  // 标题
  .form-title {
    font-size: 30px;
    margin-bottom: 15px;
  }

  .form-subtitle {
    font-size: 16px;
    margin-bottom: 40px;
  }

  // 球杆分组
  .cue-group-title {
    font-size: 20px;
    margin: 15px 0 20px 0;
  }

  .cue-group-item {
    padding: 20px;
    margin-bottom: 20px;
  }

  .group-header {
    margin-bottom: 20px;
  }

  .group-label {
    font-size: 18px;
  }

  // 输入框
  .form-input, ::v-deep .el-date-editor {
    font-size: 17px;
    border-radius: 20px;
  }

  .form-input:not(textarea), ::v-deep .el-date-editor {
    height: 52px;
    padding: 0 52px;
  }

  // 表单标签
  ::v-deep .el-form-item__label {
    font-size: 17px;
    margin-bottom: 12px;
  }

  // 按钮
  .add-group-btn {
    height: 52px;
    font-size: 17px;
    border-radius: 20px;
  }

  .submit-btn {
    height: 52px;
    font-size: 18px;
    max-width: 180px;
  }

  // 上传区域
  .voucher-tip {
    font-size: 13px;
    margin-bottom: 10px;
  }

  /* 前缀图标居中（适配所有输入类组件） */
  ::v-deep .el-input__prefix,
  ::v-deep .el-date-editor .el-input__prefix {
    width: 48px;
    height: 100%;
  }

  ::v-deep .el-input__prefix i,
  ::v-deep .el-date-editor .el-input__prefix i {
    font-size: 18px;
  }

  /* 输入框内容区 */
  ::v-deep .el-input__inner {
    height: 100%;
    line-height: 48px;
    font-size: 17px;
  }
  /* 错误提示 */
  ::v-deep .el-form-item__error {
    font-size: 16px;
    padding-top: 3px;
    padding-left: 10px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
}

// ========== PC端适配（≥1201px） ==========
@media screen and (min-width: 1201px) {
  .form-container {
    padding: 40px;
    align-items: center;
    min-height: 100vh;
  }

  .form-card {
    max-width: 800px;
    padding: 60px 50px;
    margin-top: 0;
  }

  // 返回按钮
  .back-btn {
    width: 48px;
    height: 48px;
    transition: all 0.2s ease;

    &:hover {
      background-color: #e8f4f8;
      transform: scale(1.05);
    }

    &:active {
      transform: scale(0.98);
    }

    .back-icon {
      font-size: 24px;
    }
  }

  // 标题
  .form-title {
    font-size: 36px;
    margin-bottom: 20px;
  }

  .form-subtitle {
    font-size: 18px;
    margin-bottom: 50px;
  }

  // 球杆分组
  .cue-group-title {
    font-size: 22px;
    margin: 20px 0 25px 0;
  }

  .cue-group-container {
    // PC端分组横向排列（最多2列）
    .cue-group-list {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
      gap: 20px;
    }
  }

  .cue-group-item {
    padding: 25px;
    margin-bottom: 20px;
    transition: box-shadow 0.2s ease;

    &:hover {
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
    }
  }

  .group-header {
    margin-bottom: 25px;
  }

  .group-label {
    font-size: 20px;
  }

  .delete-group-btn {
    font-size: 15px;
    transition: color 0.2s ease;

    &:hover {
      color: #e64949;
    }
  }

  // 输入框
  .form-input, ::v-deep .el-date-editor {
    font-size: 18px;
    border-radius: 22px;
    transition: border-color 0.2s ease;

    &:focus {
      border-color: #409eff;
      box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
    }
  }

  .form-input:not(textarea), ::v-deep .el-date-editor {
    height: 56px;
    padding: 0 56px;
  }

  // 表单标签
  ::v-deep .el-form-item__label {
    font-size: 18px;
    margin-bottom: 15px;
  }

  // 错误提示
  ::v-deep .el-form-item__error {
    font-size: 13px;
  }

  // 按钮
  .add-group-btn {
    height: 56px;
    font-size: 18px;
    border-radius: 22px;
    transition: all 0.2s ease;

    &:hover {
      color: #3390ff;
      border-color: #3390ff;
      background-color: rgba(64, 158, 255, 0.05);
    }
  }

  .submit-btn {
    height: 56px;
    font-size: 19px;
    max-width: 200px;
    transition: all 0.2s ease;

    &:hover {
      background: #3390ff;
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(64, 158, 255, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }

  // 上传区域
  .voucher-tip {
    font-size: 14px;
    margin-bottom: 12px;
  }
}
</style>

<style lang="scss">
// 上传组件全局样式（非scoped）
.avatar-uploader {
  // 移动端
  @media screen and (max-width: 768px) {
    .el-upload--picture-card {
      width: 100px !important;
      height: 100px !important;
      line-height: 100px !important;
      font-size: 20px !important;
    }
  }

  // 平板
  @media screen and (min-width: 769px) and (max-width: 1200px) {
    .el-upload--picture-card {
      width: 110px !important;
      height: 110px !important;
      line-height: 110px !important;
      font-size: 22px !important;
    }
  }

  // PC端
  @media screen and (min-width: 1201px) {
    .el-upload--picture-card {
      width: 120px !important;
      height: 120px !important;
      line-height: 120px !important;
      font-size: 24px !important;
      transition: all 0.2s ease;

      &:hover {
        transform: scale(1.05);
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
      }
    }
  }
}

.el-upload-list--picture-card {
  // 移动端
  @media screen and (max-width: 768px) {
    .el-upload-list__item {
      width: 100px !important;
      height: 100px !important;
      margin-right: 10px !important;
      margin-bottom: 10px !important;
      position: relative;
    }
  }

  // 平板
  @media screen and (min-width: 769px) and (max-width: 1200px) {
    .el-upload-list__item {
      width: 110px !important;
      height: 110px !important;
      margin-right: 12px !important;
      margin-bottom: 12px !important;
    }
  }

  // PC端
  @media screen and (min-width: 1201px) {
    .el-upload-list__item {
      width: 120px !important;
      height: 120px !important;
      margin-right: 15px !important;
      margin-bottom: 15px !important;
      transition: all 0.2s ease;

      &:hover {
        transform: scale(1.03);
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
      }
    }
  }

  // 已上传图片预览图适配
  .el-upload-list__item-thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  // 删除按钮样式
  .el-upload-list__item-delete {
    font-size: 16px !important;
    top: 5px !important;
    right: 5px !important;
    width: 20px !important;
    height: 20px !important;
    line-height: 20px !important;
    border-radius: 50%;
    background: rgba(0,0,0,0.5);
    color: #fff !important;
    text-align: center;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(245, 108, 108, 0.8);
      transform: scale(1.1);
    }
  }

  // 预览按钮样式
  .el-upload-list__item-preview {
    font-size: 16px !important;
    top: 5px !important;
    right: 30px !important;
    width: 20px !important;
    height: 20px !important;
    line-height: 20px !important;
    border-radius: 50%;
    background: rgba(0,0,0,0.5);
    color: #fff !important;
    text-align: center;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(64, 158, 255, 0.8);
      transform: scale(1.1);
    }

    // 预览图标居中
    .el-icon-zoom-in {
      font-size: 14px !important;
      line-height: 20px !important;
    }
  }
}
</style>